import { Link } from "react-router";

import { DescriptionList } from "@prequel/shared-components";

import Timestamp from "@/components/Timestamp";
import { useStreamContext } from "@/pages/import/StreamsPage/StreamPage";

const StreamDetails = () => {
  const { stream } = useStreamContext();

  return (
    <div className="mt-6">
      <DescriptionList>
        <DescriptionList.Item label="ID" value={stream.id} />
        <DescriptionList.Item label="Name" value={stream.name} />
        <DescriptionList.Item
          label="Destination ID"
          value={
            <Link
              className="
                text-primary-600
                hover:underline
              "
              to={`/import/destinations/${stream.destination_id}`}
            >
              {stream.destination_id}
            </Link>
          }
        />
        <DescriptionList.Item
          label="Dataset ID"
          value={
            <Link
              className="
                text-primary-600
                hover:underline
              "
              to={`/import/datasets/${stream.dataset_id}`}
            >
              {stream.dataset_id}
            </Link>
          }
        />
        <DescriptionList.Item label="Enabled" value={stream.is_enabled ? "Yes" : "No"} />
        <DescriptionList.CodeBlockItem label="Mappings" value={JSON.stringify(stream.mappings, null, 2)} />
        <DescriptionList.Item label="Created" value={<Timestamp timestamp={stream.created_at} />} />
        <DescriptionList.Item label="Updated" value={<Timestamp timestamp={stream.updated_at} />} />
      </DescriptionList>
    </div>
  );
};

export default StreamDetails;
